module.exports = __webpack_public_path__ + "static/media/style.2ba87862.JPG";